export default "__VITE_ASSET__208b1d1d__"